function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "iconfinder_icons_statistics_1564531",
  transform: "translate(-1 -2)"
}, React.createElement("g", {
  id: "statistics",
  transform: "translate(1 2)"
}, React.createElement("path", {
  id: "Path_99",
  "data-name": "Path 99",
  d: "M3.727,12H2.364A1.368,1.368,0,0,0,1,13.364v4.091a1.368,1.368,0,0,0,1.364,1.364H3.727a1.368,1.368,0,0,0,1.364-1.364V13.364A1.368,1.368,0,0,0,3.727,12Z",
  transform: "translate(-1 -5.182)"
}), React.createElement("path", {
  id: "Path_100",
  "data-name": "Path 100",
  d: "M11.727,2H10.364A1.368,1.368,0,0,0,9,3.364V14.273a1.368,1.368,0,0,0,1.364,1.364h1.364a1.368,1.368,0,0,0,1.364-1.364V3.364A1.368,1.368,0,0,0,11.727,2Z",
  transform: "translate(-3.545 -2)"
}), React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  d: "M19.727,8H18.364A1.368,1.368,0,0,0,17,9.364v6.818a1.368,1.368,0,0,0,1.364,1.364h1.364a1.368,1.368,0,0,0,1.364-1.364V9.364A1.368,1.368,0,0,0,19.727,8Z",
  transform: "translate(-6.091 -3.909)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 13.637,
    viewBox: "0 0 15 13.637"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/reports.1434d5a5.svg";
export { SvgComponent as ReactComponent };